function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { text } from '../../fe-brary-override';
var colors = tokens.colors,
  typography = tokens.typography;
var defaultColours = {
  message: text,
  icon: colors.neutral.heavy.default,
  closeIcon: colors.neutral.medium.default
};
var appearanceMap = {
  info: _objectSpread(_objectSpread({}, defaultColours), {}, {
    background: colors.info.subdued.default
  }),
  warning: _objectSpread(_objectSpread({}, defaultColours), {}, {
    background: colors.warning.subdued.default
  }),
  error: _objectSpread(_objectSpread({}, defaultColours), {}, {
    background: colors.critical.subdued.default,
    icon: colors.critical.heavy.default
  }),
  success: _objectSpread(_objectSpread({}, defaultColours), {}, {
    background: colors.success.subdued.default
  })
};
var _ref = {
  name: "19idom",
  styles: "margin-bottom:8px;"
};
var _ref2 = {
  name: "4cxybv",
  styles: "padding-bottom:8px;"
};
var _ref3 = {
  name: "70qvj9",
  styles: "display:flex;align-items:center;"
};
var _ref4 = {
  name: "12z0wuy",
  styles: "margin-right:8px;"
};
var _ref5 = {
  name: "5ahd3e",
  styles: "margin-left:8px;align-self:flex-start;"
};
var _ref6 = {
  name: "3o0h5k",
  styles: "width:16px;height:16px;"
};
export default (function () {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$appearance = _ref7.appearance,
    appearance = _ref7$appearance === void 0 ? 'info' : _ref7$appearance,
    colours = _ref7.colours,
    multiLine = _ref7.multiLine;
  var itemMargin = multiLine && _ref;
  var finalColours = _objectSpread(_objectSpread({}, appearanceMap[appearance] || appearanceMap.info), colours);
  var messageBox = /*#__PURE__*/css("background-color:", finalColours.background, ";color:", finalColours.message, ";padding:16px;border-radius:4px;display:flex;", multiLine && _ref2);
  var messageContent = /*#__PURE__*/css("flex-grow:1;", !multiLine && _ref3);
  var title = /*#__PURE__*/css(applyFont(typography.subheading), ";color:", finalColours.title, ";", itemMargin, ";display:flex;justify-content:space-between;");
  var singleLineTitle = _ref4;
  var message = /*#__PURE__*/css(applyFont(typography.body), ";flex-grow:1;", itemMargin, ";");
  var icon = /*#__PURE__*/css("color:", finalColours.icon, ";margin-right:12px;flex-shrink:0;");
  var action = /*#__PURE__*/css("color:", finalColours.action, ";padding:0;height:auto;border-width:0;", !multiLine && _ref5, " ", itemMargin, ";");
  var close = /*#__PURE__*/css("color:", finalColours.closeIcon, ";line-height:16px;margin-left:8px;padding:0;height:auto;align-self:flex-start;");
  var closeIcon = _ref6;
  return {
    messageBox,
    messageContent,
    title,
    singleLineTitle,
    message,
    icon,
    action,
    close,
    closeIcon
  };
});